import { gql } from '@grandvisionhq/graphql';

var GET_SOCIAL_IDENTITY = gql`
  query getSocialIdentity {
    me {
      id
      accountMetaData {
        isSocialIdentity
      }
    }
  }
`;

export { GET_SOCIAL_IDENTITY as default };
//# sourceMappingURL=get-social-identity.js.map
